import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import ReactFinalForm from 'components/form/ReactFinalForm';
import { IdentityField } from 'components/form/IdentityField';
import { AutocompleteAdapter } from 'components/form/AutocompleteAdapter';
import { useTranslation } from 'react-i18next';
import toast from 'features/toast';
import { equipmentApi } from './api';
import { useEquipmentCostLinkOptions } from './hooks';
import { EquipmentLinkMode } from './types';

export default function EquipmentToCostDialog(props: {
  equipmentId: number;
  mode: EquipmentLinkMode;
  setMode: (mode: EquipmentLinkMode) => void;
  callback?: () => void;
}) {
  const { t } = useTranslation();

  const { equipmentId, mode, setMode, callback } = props;
  const { options } = useEquipmentCostLinkOptions(mode);

  const handleClose = () => {
    setMode('');
  };

  const onSubmit = (values: { object_id: number }) => {
    equipmentApi.addCostLink(equipmentId, mode, values.object_id).then(() => {
      toast.success('Fonte di costo aggiunta.');
      handleClose();
      if (callback) callback();
    });
  };

  return (
    <Dialog fullWidth maxWidth="sm" open={mode.length > 0} onClose={handleClose}>
      <DialogTitle>Aggiungi fonte di costo</DialogTitle>
      <DialogContent>
        <ReactFinalForm onSubmit={onSubmit} formId="addCostLink" hideControls>
          <div className="w-full my-4">
            {options && (
              <IdentityField
                name="object_id"
                component={AutocompleteAdapter}
                options={options}
                label={t('global.cost-source')}
              />
            )}
          </div>
        </ReactFinalForm>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>{t('actions.cancel')}</Button>
        <Button type="submit" form="addCostLink">
          {t('global.add')}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
